/**
 * Названия управляющих элементов сигареты
 *
 * destination - tourists - поля
 *
 * popularCountries, metaregions - "Популярные страны" и
 * "Отдых по впечатлениям" соответственно в выпадающем
 * списке destination
 *
 * submit - кнопка "Найти"
 */
export const FIELD_NAMES = {
  destination: 'destination',
  datepicker: 'datepicker',
  departure: 'departure',
  tourists: 'tourists',
  popularCountries: 'popularCountries',
  metaregions: 'metaregions',
  submit: 'submit',
} as const;

export const INITIAL_VALUES_FORMIK = {
  destination: undefined,
  datepicker: undefined,
  departure: undefined,
  tourists: { adults: 2, kids: [] },
};

export const LEFT_BORDER_CLASS = 'cigarette__field-border';

export const storageKeys = {
  // ключ для хранения последнего выбранного пункта в поле город вылета
  departure: 'lt-departure-city',
  // ключ для последних 3 значений сигареты, используется для предыдущих поисков
  landParams: 'lt-land-params',
};

export const DEPARTURE_FOR_INIT = {
  label: 'Москва',
  value: 'Moscow',
  selectedLabel: 'Москвы',
};

export const NUMBER_DAYS_SAVE_GEO = 2;
export const LAND_PARAMS_COUNT = 3;

export const SEARCH_TYPE_NAMES = {
  PACKAGE: 'package',
  HOTEL: 'hotel',
  TRIP: 'trip',
} as const;
export const DEFAULT_DEPARTURE_COUNTRY_ISO2 = 'RU';

export const enToRusKeyboardMap = new Map([
  ['q', 'й'],
  ['w', 'ц'],
  ['e', 'у'],
  ['r', 'к'],
  ['t', 'е'],
  ['y', 'н'],
  ['u', 'г'],
  ['i', 'ш'],
  ['o', 'щ'],
  ['p', 'з'],
  ['[', 'х'],
  ['{', 'х'],
  [']', 'ъ'],
  ['}', 'ъ'],
  ['a', 'ф'],
  ['s', 'ы'],
  ['d', 'в'],
  ['f', 'а'],
  ['g', 'п'],
  ['h', 'р'],
  ['j', 'о'],
  ['k', 'л'],
  ['l', 'д'],
  [';', 'ж'],
  ["'", 'э'],
  ['"', 'э'],
  ['\\', 'ё'],
  ['|', 'ё'],
  ['z', 'я'],
  ['x', 'ч'],
  ['c', 'с'],
  ['v', 'м'],
  ['b', 'и'],
  ['n', 'т'],
  ['m', 'ь'],
  [',', 'б'],
  ['<', 'б'],
  ['.', 'ю'],
  ['>', 'ю'],
]);

export const DEFAULT_TRACKER_PARAMS = {
  end_date_from: null,
  end_date_till: null,
  start_date_preset: null,
  nights_preset: null,
};

export const TRIPSTER_API_PATH =
  'https://experience.tripster.ru/api/partners/leveltravelapi/search/site/';

export const DEFAULT_TRIPSTER_START_OPTIONS = [
  {
    groupName: 'popularCountries' as const,
    options: [],
  },
  {
    groupName: 'metaregions' as const,
    options: [],
  },
];

export const DEFAULT_TRIPSTER_FULL_OPTIONS = [
  {
    groupName: 'allCountries' as const,
    options: [],
  },
  {
    groupName: 'allMetaregions' as const,
    options: [],
  },
];
